// Main VijiCore class
export { VijiCore } from './VijiCore.js';

// Public types and interfaces
export type {
  VijiCoreConfig,
  Resolution,
  CaptureFrameOptions,
  ParameterGroup,
  ParameterDefinition,
  ParameterConfig,
  AnalysisConfiguration,
  FrequencyBand,
  PerformanceStats,
  VijiAPI,
  AudioAPI,
  VideoAPI,
  FaceData,
  HandData,
  MouseAPI,
  KeyboardAPI,
  TouchAPI,
  ParameterAPI
} from './types/index.js';

// Error class
export { VijiCoreError } from './types/index.js';

// Version information
export const VERSION = '0.2.20'; 